import React from 'react'
import { useFormContext } from 'react-hook-form'

import useIntl from 'hooks/useIntl'
import { EnumPipelineType } from 'hooks/useApollo'
import TeamDetailsForm from 'screens/Onboarding/components/TeamDetailsForm'
import { useCreateAssessment } from 'screens/Onboarding/hooks/useCreateAssessment'

import {
	useOnboardingStore,
	resetOnboardingStore
} from '../../../../hooks/useOnboardingStore'

import { EntryFormType } from '../../EntryForm.types'
import { resetEntryFormStore, useEntryFormStore } from '../../hooks/useEntryFormStore'

const convertDurationToMinutes = (time: string): number => {
	if (!time) return 0
	const [hours, minutes] = time.split(':').map(Number)
	return (hours || 0) * 60 + (minutes || 0)
}

export const EntryFormTeamCreation: React.FC = () => {
	const intl = useIntl()
	const { control, getValues, formState } = useFormContext<EntryFormType>()
	const { currentStep, prevStep, toggleHelpGuide } = useOnboardingStore(state => state)

	const formData = useEntryFormStore(state => state.formData)
	const formStates = useEntryFormStore(state => state.formStates)

	const resetStore = () => {
		resetOnboardingStore()
		resetEntryFormStore()
	}

	const [{ loading }, { createAssessment }] = useCreateAssessment(resetStore)

	const handleBack = () => {
		prevStep()
	}

	const cleanTimerValue = formData?.timer.replace(/[^0-9:]/g, '') || '00:00'
	const totalMinutes = convertDurationToMinutes(cleanTimerValue)

	const handleContinue = () => {
		const { team, talentGroup, chapters, challengePack } = getValues()
		const { formData } = useEntryFormStore.getState()

		createAssessment({
			variables: {
				assessmentInput: {
					challengePack,
					name: team.name,
					masking: team.maskChallenge,
					chapters,
					duration: String(totalMinutes),
					questionPicking: formData?.picking,
					fromSection: formStates?.chartData.map(data => ({
						sectionId: data.sectionId,
						sectionName: data.type,
						noOfQuestions: data.questions,
						subSectionId: data.subSectionId,
						subSectionName: data.subTypes
					})),
					objective: 'Benchmarking'
				},
				emailsToInvite: talentGroup.teammateEmails,
				pipelineInput: {
					name: talentGroup.name,
					color: talentGroup.color,
					type: talentGroup.type as EnumPipelineType
				}
			}
		})
	}

	return (
		<TeamDetailsForm
			title={intl.formatMessage({
				id: `onboarding.free.form.step.${currentStep}.title`
			})}
			subTitle={intl.formatMessage({ id: 'onboarding.select.entry.level.title' })}
			onBack={handleBack}
			onContinue={handleContinue}
			control={control}
			loading={loading}
			isValid={!formState.isValid}
			currentStep={currentStep}
			onShowHelpGuide={toggleHelpGuide}
		/>
	)
}

export default EntryFormTeamCreation
